import React from 'react';
import { months, responsiveSizeTimesheet, timesheetsStatuses } from '../../../../../utils/constants';

export const ExpenseHeaderConfig = (t, data, submissionType, size, classes, isApprover) => {
  return {
    headerLeft:
      size.width > responsiveSizeTimesheet ? (
        <p className={classes.monthLabel}>{data?.ClaimDescription}</p>
      ) : (
        <div className={classes.mobileClientPlacement}>
          <p className={classes.clientName}>
            {isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName}
          </p>
          ,&nbsp;
          <p className={classes.placement}>{data?.JobTitle}</p>
        </div>
      ),
    keyValueLabels: [
      {
        label: isApprover ? t('dashboard.timesheet.header.contractor') : t('dashboard.timesheet.header.client'),
        value: isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName
      },
      {
        label: t('dashboard.timesheet.header.jobtitle'),
        value: data?.JobTitle
      },
      {
        label: t('dashboard.timesheet.header.recordn'),
        value: data?.RecordNo
      },
      {
        label: t('dashboard.timesheet.header.order'),
        value: data?.PoNumber || '-'
      }
    ]
  };
};
